import React from 'react';
import { useTranslation } from 'react-i18next';

import { SearchResults } from '@uncinc/react-searchkit';

import type { SearchAllContentHit } from '../types';
import Hit from './Hit';

const SearchAllContentResults = () => {
  const { t } = useTranslation();

  return (
    <SearchResults
      className="SearchAllContent__Results"
      renderItem={(hit: SearchAllContentHit) => <Hit hit={hit} />}
      emptyState={(
        <div>
          {t('searchkit.empty_state.title')}
        </div>
      )}
    />
  );
};

export default SearchAllContentResults;
